


















































import { Button } from 'element-ui'
import { Vue, Prop, Component } from 'vue-property-decorator'

import Booking from '@/models/booking'

@Component({
  components: {
    [Button.name]: Button,
  },
})
export default class PresetPaymentOption extends Vue {
  @Prop() booking!: Booking
  @Prop() depositsAmount!: number
  @Prop() amountToPay!: number
  @Prop() totalError!: string
  @Prop({ type: Number, default: 99 }) maxDeposits!: number

  increment() {
    if (this.depositsAmount >= this.maxDeposits) {
      return
    }
    this.$emit('on-deposits-amount-update', this.depositsAmount + 1)
  }

  decrement() {
    if (this.depositsAmount > 1) {
      this.$emit('on-deposits-amount-update', this.depositsAmount - 1)
    }
  }
}
